// src/pages/Home.jsx
import React from 'react'
import HeroSlider from '../components/home/HeroSlider'
import AboutSection from '../components/home/AboutSection'
import UniformsSection from '../components/home/UniformsSection'
import ProgramsSection from '../components/home/ProgramsSection'
import TestimonialsSection from '../components/home/TestimonialsSection'

const Home = () => {
  return (
    <div>
      <HeroSlider />
      <AboutSection />
      <UniformsSection />
      <ProgramsSection />
      <TestimonialsSection />
    </div>
  )
}

export default Home